import { render } from "./GeofenceHistory.vue?vue&type=template&id=2bdcd11a&scoped=true"
import script from "./GeofenceHistory.vue?vue&type=script&lang=js"
export * from "./GeofenceHistory.vue?vue&type=script&lang=js"

import "./GeofenceHistory.vue?vue&type=style&index=0&id=2bdcd11a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdcd11a"]])

export default __exports__